//resolve o roleId do usuário de forma consistente
import { ROLE } from "./menu.config";

export function resolveRoleId(perfil) {
  if (!perfil) return null;

  if (typeof perfil === "number") return perfil;

  const candidate = perfil.idPerfil ?? perfil.id ?? null;
  const n = candidate != null ? Number(candidate) : null;

  if (!Number.isFinite(n)) return null;

  const known = n != null && Object.values(ROLE).includes(n as number);
  return known ? n : n;
}


export function readPerfilComFallbackLocalStorage(perfil: unknown): unknown {
  if (perfil != null && perfil !== "") return perfil;
  try {
    const raw = localStorage.getItem("perfil");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}


export function podeChamarGetAnaliseAvaliacao(perfil: unknown): boolean {
  const merged = readPerfilComFallbackLocalStorage(perfil);
  const id = resolveRoleId(merged);
  return (
    id === ROLE.ADMIN_TI || id === ROLE.ADMIN || id === ROLE.ANALISTA
  );
}
